import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime, msgStatusColor } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

const FILTERS = [
  { key: "", label: "Todas" },
  { key: "ENVIADA", label: "Enviadas" },
  { key: "PENDENTE", label: "Pendentes" },
  { key: "ERRO", label: "Erros" },
  { key: "CANCELADA", label: "Canceladas" },
];

export default function History() {
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const params = status ? { status } : {};
    api.get("/messages", { params }).then((r) => setMessages(r.data));
  }, [status]);

  const filtered = messages.filter((m) =>
    !search || m.client_name?.toLowerCase().includes(search.toLowerCase()) || m.whatsapp?.includes(search)
  );

  return (
    <div className="space-y-6 animate-fade-up" data-testid="history-page">
      <div><h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Histórico de Mensagens</h1><p className="text-sm text-slate-500 mt-1">Todo o registro de comunicação com os clientes.</p></div>

      <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm space-y-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input placeholder="Pesquisar por cliente ou WhatsApp..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-10" data-testid="history-search" />
        </div>
        <div className="flex flex-wrap gap-2">
          {FILTERS.map((f) => (
            <button key={f.key} onClick={() => setStatus(f.key)} data-testid={`history-filter-${f.key || "all"}`}
              className={`text-xs font-medium px-3 py-1.5 rounded-full border ${status === f.key ? "bg-emerald-500 text-white border-emerald-500" : "bg-white text-slate-600 border-slate-200 hover:border-emerald-300"}`}>{f.label}</button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="history-table">
            <thead>
              <tr className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
                <th className="px-4 py-3 text-left">Cliente</th>
                <th className="px-4 py-3 text-left">WhatsApp</th>
                <th className="px-4 py-3 text-left hidden md:table-cell">Mensagem</th>
                <th className="px-4 py-3 text-left hidden lg:table-cell">Campanha</th>
                <th className="px-4 py-3 text-left">Data</th>
                <th className="px-4 py-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filtered.length === 0 ? (
                <tr><td colSpan={6} className="text-center py-12 text-slate-400">Nenhuma mensagem encontrada.</td></tr>
              ) : filtered.map((m) => (
                <tr key={m.id} className="hover:bg-slate-50">
                  <td className="px-4 py-3 font-medium text-slate-800">{m.client_name}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-600">{m.whatsapp}</td>
                  <td className="px-4 py-3 text-slate-500 max-w-xs truncate hidden md:table-cell">{m.content}</td>
                  <td className="px-4 py-3 text-slate-500 hidden lg:table-cell">{m.campaign_name || "—"}</td>
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{fmtDateTime(m.created_at)}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full border ${msgStatusColor(m.status)}`}>{m.status}</span>{m.status === "ERRO" && m.error_reason && <span className="block text-[10px] text-red-500 mt-1" data-testid="msg-error-reason">{m.error_reason}</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
